import React from 'react';
import { aboutData } from '../../data/mock';
import { Globe, Headphones, Sparkles, Briefcase } from 'lucide-react';

const valueIcons = [
  Globe,          // Bespoke Planning - globe/world coverage
  Headphones,     // Direct Access - personal contact 24/7
  Sparkles,       // Exclusive Rates - premium/special pricing
  Briefcase,      // All Things Travel - comprehensive travel services
];

const About = () => {
  return (
    <section id="about" className="bg-[#c4b49a] py-16 sm:py-24 lg:py-32">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2
            className="text-[#0a1628] text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light tracking-wide mb-4 sm:mb-6"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {aboutData.tagline}
          </h2>
          <p
            className="text-[#0a1628] text-base sm:text-lg md:text-xl font-light mb-6 sm:mb-8"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {aboutData.title}
          </p>
          
          {/* Main Description */}
          <p
            className="text-[#0a1628]/90 text-sm sm:text-base max-w-3xl mx-auto leading-relaxed font-light px-2 mb-6"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            {aboutData.description}
          </p>
          
          {/* Extended Description */}
          <div className="max-w-4xl mx-auto space-y-4 sm:space-y-5 px-2">
            {aboutData.extendedDescription && aboutData.extendedDescription.map((paragraph, index) => (
              <p
                key={index}
                className="text-[#0a1628]/80 text-sm sm:text-base leading-relaxed font-light"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {paragraph}
              </p>
            ))}
          </div>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-8 mt-12 sm:mt-16">
          {aboutData.values.map((value, index) => {
            const IconComponent = valueIcons[index];
            return (
              <div key={index} className="text-center group p-2 sm:p-0">
                <div className="w-12 h-12 sm:w-16 sm:h-16 mx-auto mb-3 sm:mb-5 border border-[#0a1628]/30 flex items-center justify-center transition-all duration-300 group-hover:border-white group-hover:bg-white/20">
                  <IconComponent 
                    size={20} 
                    strokeWidth={1.5}
                    className="text-[#0a1628] group-hover:text-white transition-colors duration-300 sm:w-6 sm:h-6"
                  />
                </div>
                <h3
                  className="text-[#0a1628] text-xs sm:text-sm font-medium tracking-wide mb-1 sm:mb-2 uppercase"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {value.title}
                </h3>
                <p
                  className="text-[#0a1628]/80 text-xs sm:text-sm font-light leading-relaxed"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {value.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
